import { useQuery } from "@tanstack/react-query";

import { SweetOrHotApi } from "../api/SweetOrHot.api";

export const useSweetOrHotLadies = () => {
  return useQuery({
    queryKey: ["SWEET_OR_HOT_LADIES"],
    queryFn: async () => {
      return SweetOrHotApi.get();
    },
    staleTime: 0,
    cacheTime: 0,
  });
};
